function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -.8696 1.8202)",
  x: 37.9,
  y: 62.3,
  width: 253.6,
  height: 34.9,
  fill: "#39B54A"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -.8696 1.8202)",
  x: 131.5,
  y: 62.3,
  width: 66.4,
  height: 34.9,
  fill: "#EFEDB4"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.01101 .01101 .9999 -.8722 1.5343)",
  x: 136.8,
  y: 62.5,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011034 .011034 .9999 -.8654 2.1057)",
  x: 188.3,
  y: 62,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -1.0262 1.8233)",
  x: 38.1,
  y: 90.7,
  width: 253.6,
  height: 6.5,
  fill: "#ccc"
});

var _ref7 = /*#__PURE__*/React.createElement("polygon", {
  points: "291.3 61 37.7 63.8 51.2 50.4 278.6 47.8",
  fill: "#289C46"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  points: "197.7 62 131.3 62.7 136.5 49.4 192.3 48.8",
  fill: "#EDEBA0"
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  points: "140.9 62.6 136.6 62.7 141.8 49.4 146.1 49.3",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  points: "192.4 62.1 188.1 62.1 182.7 48.9 187 48.9",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -1.2529 1.8852)",
  x: 43.6,
  y: 97.1,
  width: 253.6,
  height: 34.9,
  fill: "#39B54A"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -1.253 1.8852)",
  x: 137.2,
  y: 97.1,
  width: 66.4,
  height: 34.9,
  fill: "#EFEDB4"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.01101 .01101 .9999 -1.2561 1.5991)",
  x: 142.5,
  y: 97.4,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011034 .011034 .9999 -1.249 2.1707)",
  x: 194,
  y: 96.8,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -1.4106 1.8882)",
  x: 43.8,
  y: 125.6,
  width: 253.6,
  height: 6.5,
  fill: "#ccc"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -1.6391 1.8333)",
  x: 38.7,
  y: 132.1,
  width: 253.6,
  height: 34.9,
  fill: "#39B54A"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -1.6391 1.8333)",
  x: 132.3,
  y: 132.1,
  width: 66.4,
  height: 34.9,
  fill: "#EFEDB4"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.01101 .01101 .9999 -1.6417 1.5473)",
  x: 137.6,
  y: 132.4,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.01101 .01101 .9999 -1.6321 2.1143)",
  x: 189.1,
  y: 131.8,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -1.7967 1.8352)",
  x: 38.8,
  y: 160.6,
  width: 253.6,
  height: 6.5,
  fill: "#ccc"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -2.0236 1.8685)",
  x: 41.7,
  y: 167,
  width: 253.6,
  height: 34.9,
  fill: "#39B54A"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -2.0237 1.8685)",
  x: 135.3,
  y: 167,
  width: 66.4,
  height: 34.9,
  fill: "#EFEDB4"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011034 .011034 .9999 -2.0301 1.5859)",
  x: 140.6,
  y: 167.3,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011033 .011033 .9999 -2.0203 2.154)",
  x: 192.1,
  y: 166.7,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -2.1802 1.8715)",
  x: 41.9,
  y: 195.4,
  width: 253.6,
  height: 6.5,
  fill: "#ccc"
});

var _ref26 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -2.41 1.7868)",
  x: 34.1,
  y: 202,
  width: 253.6,
  height: 34.9,
  fill: "#39B54A"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -2.41 1.7879)",
  x: 127.8,
  y: 202,
  width: 66.4,
  height: 34.9,
  fill: "#EFEDB4"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.01101 .01101 .9999 -2.4116 1.502)",
  x: 133.1,
  y: 202.3,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011033 .011033 .9999 -2.4069 2.0734)",
  x: 184.6,
  y: 201.7,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -2.5676 1.7899)",
  x: 34.3,
  y: 230.5,
  width: 253.6,
  height: 6.5,
  fill: "#ccc"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -2.7929 1.9102)",
  x: 45.1,
  y: 236.8,
  width: 253.6,
  height: 34.9,
  fill: "#39B54A"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -2.793 1.9102)",
  x: 138.7,
  y: 236.8,
  width: 66.4,
  height: 34.9,
  fill: "#EFEDB4"
});

var _ref33 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.01101 .01101 .9999 -2.7941 1.6252)",
  x: 144.1,
  y: 237.1,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.01101 .01101 .9999 -2.7844 2.1911)",
  x: 195.5,
  y: 236.5,
  width: 4.3,
  height: 34.9,
  fill: "#fff"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011025 .011025 .9999 -2.9506 1.9133)",
  x: 45.3,
  y: 265.3,
  width: 253.6,
  height: 6.5,
  fill: "#ccc"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "m204 4.9c-15.1 0.2-27.3 4-27.2 8.6l0.4 33.1c0 1.5 1.4 2.9 3.7 4.1 4.7 2.4 13.6 4 23.7 3.9s18.9-1.9 23.6-4.4c2.3-1.2 3.6-2.7 3.6-4.2l-0.4-33.1c0-4.6-12.3-8.1-27.4-8z",
  fill: "#FADD75"
});

var _ref37 = /*#__PURE__*/React.createElement("g", {
  fill: "#FCAB1E"
}, /*#__PURE__*/React.createElement("path", {
  d: "m204.2 23.1c-10.1 0.1-19.3-1.4-24.5-4-3.7-1.9-4.5-4-4.6-5.5-0.1-6.5 14.4-10 28.8-10.2s28.9 3.1 29 9.5c0 1.4-0.7 3.6-4.4 5.6-5.1 2.7-14.2 4.5-24.3 4.6zm-0.2-16.6c-15.7 0.2-25.7 4.3-25.7 7 0 0.8 1.1 1.8 2.8 2.7 4.7 2.4 13.5 3.8 23 3.7s18.3-1.7 22.9-4.2c1.8-0.9 2.8-2 2.8-2.8 0-2.7-10.1-6.6-25.8-6.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m204.5 47.9c-14.4 0.2-28.9-3.1-29-9.5l-0.1-8.3h3.1c0 0.8 1 1.8 2.8 2.7 4.7 2.4 13.5 3.8 23 3.7s18.3-1.7 22.9-4.2c1.8-1 2.8-2 2.8-2.8h3.1l0.1 8.3c0.1 6.4-14.4 10-28.7 10.1zm-26-13.1v3.6c0 2.7 10.1 6.6 25.9 6.4 15.7-0.2 25.7-4.3 25.7-7v-3.6c-0.4 0.3-0.9 0.6-1.4 0.8-5.1 2.8-14.2 4.5-24.4 4.6-10.1 0.1-19.3-1.4-24.5-4-0.4-0.3-0.8-0.5-1.3-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m204.6 56.2c-14.4 0.2-28.9-3.1-29-9.5l-0.1-8.3h3.1c0 0.8 1 1.8 2.8 2.7 4.7 2.4 13.5 3.8 23 3.7s18.3-1.7 22.9-4.2c1.8-1 2.8-2 2.8-2.8h3.1l0.1 8.3c0.1 6.4-14.4 10-28.7 10.1zm-26-13.1v3.6c0 2.7 10.1 6.6 25.9 6.4 15.7-0.2 25.7-4.3 25.7-7v-3.6c-0.4 0.3-0.9 0.6-1.4 0.8-5.1 2.8-14.2 4.5-24.4 4.6-10.1 0.1-19.3-1.4-24.5-4-0.4-0.3-0.8-0.5-1.3-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m204.4 39.6c-10.1 0.1-19.3-1.4-24.5-4-3-1.5-4.5-3.4-4.6-5.5l-0.1-8.3h3.1c0 0.8 1 1.8 2.8 2.7 4.7 2.4 13.5 3.8 23 3.7s18.3-1.7 22.9-4.2c1.8-1 2.8-2 2.8-2.8h3.1l0.1 8.3c0 2.1-1.5 4-4.4 5.6-5 2.7-14.1 4.4-24.2 4.5zm-25.9-13.1v3.6c0 0.8 1 1.8 2.8 2.7 4.7 2.4 13.5 3.8 23 3.7s18.3-1.7 22.9-4.2c1.8-1 2.8-2 2.8-2.8v-3.6c-0.4 0.3-0.9 0.6-1.4 0.8-5.1 2.8-14.2 4.5-24.4 4.6-10.1 0.1-19.3-1.4-24.5-4-0.4-0.3-0.8-0.5-1.2-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m204.3 31.3c-10.1 0.1-19.3-1.4-24.5-4-3-1.5-4.5-3.4-4.6-5.5l-0.1-8.3h3.1c0 0.8 1.1 1.8 2.8 2.7 4.7 2.4 13.5 3.8 23 3.7s18.3-1.7 22.9-4.2c1.8-0.9 2.8-2 2.8-2.8h3.1l0.1 8.3c0 2.1-1.5 4-4.4 5.6-5 2.7-14.1 4.4-24.2 4.5zm-25.9-13.1v3.6c0 0.8 1 1.8 2.8 2.7 4.7 2.4 13.5 3.8 23 3.7s18.3-1.7 22.9-4.2c1.8-1 2.8-2 2.8-2.8v-3.6c-0.4 0.3-0.9 0.6-1.4 0.8-5.1 2.8-14.2 4.5-24.4 4.6-10.1 0.1-19.3-1.4-24.5-4-0.4-0.2-0.8-0.5-1.2-0.8z"
}));

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "m206.1 12s-0.1 0 0 0c-0.3-0.1-0.6-0.1-1-0.2-2.4-0.5-3.6-0.9-3.6-1.2 0-0.2 0.2-0.4 0.6-0.5s1-0.2 1.7-0.2c1 0 1.7 0.1 2.1 0.2 0.5 0.2 0.7 0.4 0.7 0.8v0.1l4.9-0.1v-0.2c0-0.8-0.6-1.4-1.9-1.8-0.8-0.3-1.9-0.4-3.2-0.5v-1l-4.8 0.1v1c-1.3 0.1-2.4 0.3-3.3 0.5-1.3 0.4-2 0.9-2 1.6 0 0.5 0.4 0.9 1.2 1.3s2.7 0.8 5.6 1.4c0.2 0 0.4 0.1 0.6 0.1 1.9 0.4 2.8 0.7 2.8 1 0 0.2-0.2 0.4-0.7 0.6-0.4 0.1-1.1 0.2-1.8 0.2-1 0-1.7-0.1-2.1-0.3s-0.6-0.5-0.6-1v-0.1l-5 0.1v0.2 0.1c0 0.8 0.6 1.5 1.9 1.8 0.9 0.3 2 0.4 3.5 0.5v1l4.8-0.1v-1c1.4-0.1 2.5-0.3 3.4-0.5 1.4-0.4 2-0.9 2-1.6s-1.9-1.5-5.8-2.3z",
  fill: "#fff"
});

var _ref39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "i",
  d: "m179.7 19c5.2 2.6 14.3 4.2 24.5 4 10.1-0.1 19.2-1.8 24.4-4.6 3.7-2 4.4-4.1 4.4-5.6v0l0.4 33.1c0.1 6.5-14.4 10-28.8 10.2s-28.9-3.1-29-9.5l-0.4-33.1c0 1.6 0.9 3.6 4.5 5.5z"
}));

var _ref40 = /*#__PURE__*/React.createElement("clipPath", {
  id: "h"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#i"
}));

var _ref41 = /*#__PURE__*/React.createElement("polygon", {
  points: "239.6 60 207.9 61.1 207.4 8.9 239 7.7",
  clipPath: "url(#h)",
  enableBackground: "new",
  fill: "#F8CF44",
  opacity: 0.4
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "m250.6 26.7c-14.6 0.2-26.5 3.9-26.4 8.3l0.2 15.9c0 1.5 1.3 2.8 3.6 4 4.6 2.3 13.2 3.9 23 3.8s18.4-1.8 22.9-4.3c2.2-1.2 3.5-2.6 3.5-4.1l-0.2-15.9c-0.1-4.4-12-7.9-26.6-7.7z",
  fill: "#FADD75"
});

var _ref43 = /*#__PURE__*/React.createElement("g", {
  fill: "#FCAB1E"
}, /*#__PURE__*/React.createElement("path", {
  d: "m250.8 44.3c-9.8 0.1-18.7-1.4-23.7-3.9-3.6-1.8-4.4-3.9-4.4-5.3-0.1-6.3 14-9.7 27.9-9.9s28 3 28.1 9.2c0 1.4-0.7 3.5-4.3 5.4-5 2.7-13.8 4.4-23.6 4.5zm-0.2-16.1c-15.2 0.2-24.9 4.1-24.9 6.8 0 0.8 1 1.8 2.8 2.6 4.6 2.3 13.1 3.7 22.3 3.6s17.7-1.7 22.2-4.1c1.7-0.9 2.7-1.9 2.7-2.7-0.1-2.6-9.9-6.4-25.1-6.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m250.9 60.3c-9.8 0.1-18.7-1.4-23.7-3.9-2.9-1.5-4.4-3.3-4.4-5.3l-0.1-8h3c0 0.8 1 1.8 2.8 2.6 4.6 2.3 13.1 3.7 22.3 3.6s17.7-1.7 22.2-4.1c1.7-0.9 2.7-1.9 2.7-2.7h3l0.1 8c0 2-1.4 3.9-4.3 5.4-4.9 2.6-13.8 4.3-23.6 4.4zm-25.1-12.7v3.5c0 0.8 1 1.8 2.8 2.6 4.6 2.3 13.1 3.7 22.3 3.6s17.7-1.7 22.2-4.1c1.7-0.9 2.7-1.9 2.7-2.7v-3.5c-0.4 0.3-0.8 0.5-1.3 0.8-5 2.7-13.8 4.3-23.6 4.4s-18.7-1.4-23.7-3.9c-0.5-0.2-1-0.4-1.4-0.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m250.8 52.3c-9.8 0.1-18.7-1.4-23.7-3.9-2.9-1.5-4.4-3.3-4.4-5.3l-0.1-8h3c0 0.8 1 1.8 2.8 2.6 4.6 2.3 13.1 3.7 22.3 3.6s17.7-1.7 22.2-4.1c1.7-0.9 2.7-1.9 2.7-2.7h3l0.1 8c0 2-1.4 3.9-4.3 5.4-4.9 2.6-13.8 4.3-23.6 4.4zm-25.1-12.7v3.5c0 0.8 1 1.8 2.8 2.6 4.6 2.3 13.1 3.7 22.3 3.6s17.7-1.7 22.2-4.1c1.7-0.9 2.7-1.9 2.7-2.7v-3.5c-0.4 0.3-0.8 0.5-1.3 0.8-5 2.7-13.8 4.3-23.6 4.4s-18.7-1.4-23.7-3.9c-0.5-0.2-1-0.5-1.4-0.7z"
}));

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "m252.6 34.1s-0.1 0 0 0c-0.3-0.1-0.6-0.1-0.9-0.2-2.3-0.5-3.5-0.8-3.5-1.2 0-0.2 0.2-0.4 0.6-0.5s0.9-0.2 1.6-0.2c0.9 0 1.6 0.1 2 0.2 0.4 0.2 0.7 0.4 0.7 0.8v0.1l4.8-0.1v-0.2c0-0.8-0.6-1.4-1.8-1.7-0.8-0.2-1.8-0.4-3.1-0.5v-1l-4.7 0.1v1c-1.3 0.1-2.3 0.3-3.2 0.5-1.3 0.4-1.9 0.9-1.9 1.5 0 0.5 0.4 0.9 1.2 1.3 0.8 0.3 2.6 0.8 5.4 1.4 0.1 0 0.3 0.1 0.6 0.1 1.8 0.4 2.7 0.7 2.7 1 0 0.2-0.2 0.4-0.6 0.5s-1 0.2-1.8 0.2c-1 0-1.7-0.1-2.1-0.3s-0.6-0.5-0.6-1v-0.1l-4.9 0.1v0.1 0.1c0 0.8 0.6 1.4 1.8 1.8 0.8 0.3 2 0.4 3.4 0.5v1l4.7-0.1v-1c1.3-0.1 2.4-0.3 3.3-0.5 1.3-0.4 2-0.9 2-1.6-0.1-0.5-1.9-1.3-5.7-2.1z",
  fill: "#fff"
});

var _ref45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "g",
  d: "m227.1 40.3c5 2.6 13.9 4 23.7 3.9s18.6-1.8 23.6-4.4c3.6-1.9 4.3-4 4.3-5.4v0l0.2 16c0.1 6.3-14 9.7-27.9 9.9s-28-3-28.1-9.2l-0.2-15.9c0 1.3 0.8 3.3 4.4 5.1z"
}));

var _ref46 = /*#__PURE__*/React.createElement("clipPath", {
  id: "f"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#g"
}));

var _ref47 = /*#__PURE__*/React.createElement("polygon", {
  points: "284.9 63.9 254.2 65 253.8 30.5 284.5 29.4",
  clipPath: "url(#f)",
  enableBackground: "new",
  fill: "#F8CF44",
  opacity: 0.4
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "m297.9 231.4c-15.1 0-27.3 3.7-27.3 8.3v33.1c0 1.5 1.3 2.9 3.7 4.1 4.7 2.5 13.6 4.1 23.7 4.1s19-1.7 23.7-4.1c2.3-1.2 3.7-2.6 3.7-4.1v-33.1c-0.2-4.5-12.4-8.3-27.5-8.3z",
  fill: "#FADD75"
});

var _ref49 = /*#__PURE__*/React.createElement("g", {
  fill: "#FCAB1E"
}, /*#__PURE__*/React.createElement("path", {
  d: "m297.9 249.6c-10.1 0-19.2-1.6-24.4-4.3-3.7-1.9-4.5-4.1-4.5-5.5 0-6.5 14.5-9.9 28.9-9.9s28.9 3.4 28.9 9.9c0 1.4-0.8 3.6-4.5 5.5-5.2 2.7-14.3 4.3-24.4 4.3zm0-16.6c-15.7 0-25.8 4-25.8 6.7 0 0.8 1.1 1.8 2.8 2.8 4.7 2.4 13.5 4 23 4s18.3-1.5 23-4c1.8-0.9 2.8-2 2.8-2.8 0-2.7-10.1-6.7-25.8-6.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m297.9 274.4c-14.4 0-28.9-3.4-28.9-9.9v-8.3h3.1c0 0.8 1 1.8 2.8 2.8 4.7 2.4 13.5 4 23 4s18.3-1.5 23-4c1.8-0.9 2.8-1.9 2.8-2.8h3.1v8.3c0 6.6-14.6 9.9-28.9 9.9zm-25.8-13.4v3.6c0 2.7 10 6.7 25.8 6.7 15.7 0 25.8-4 25.8-6.7v-3.6c-0.4 0.3-0.9 0.5-1.4 0.8-5.2 2.7-14.3 4.3-24.4 4.3s-19.2-1.6-24.4-4.3c-0.5-0.2-1-0.5-1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m297.9 282.7c-14.4 0-28.9-3.4-28.9-9.9v-8.3h3.1c0 0.8 1 1.8 2.8 2.8 4.7 2.4 13.5 4 23 4s18.3-1.5 23-4c1.8-0.9 2.8-1.9 2.8-2.8h3.1v8.3c0 6.5-14.6 9.9-28.9 9.9zm-25.8-13.4v3.6c0 2.7 10 6.7 25.8 6.7 15.7 0 25.8-4 25.8-6.7v-3.6c-0.4 0.3-0.9 0.5-1.4 0.8-5.2 2.7-14.3 4.3-24.4 4.3s-19.2-1.6-24.4-4.3c-0.5-0.2-1-0.5-1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m297.9 266.1c-10.1 0-19.2-1.6-24.4-4.3-3-1.6-4.5-3.4-4.5-5.5v-8.3h3.1c0 0.8 1 1.8 2.8 2.8 4.7 2.4 13.5 4 23 4s18.3-1.5 23-4c1.8-0.9 2.8-1.9 2.8-2.8h3.1v8.3c0 2.1-1.5 4-4.5 5.5-5.2 2.7-14.3 4.3-24.4 4.3zm-25.8-13.4v3.6c0 0.8 1 1.8 2.8 2.8 4.7 2.4 13.5 4 23 4s18.3-1.5 23-4c1.8-0.9 2.8-1.9 2.8-2.8v-3.6c-0.4 0.3-0.9 0.5-1.4 0.8-5.2 2.7-14.3 4.3-24.4 4.3s-19.2-1.6-24.4-4.3c-0.5-0.2-1-0.5-1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m297.9 257.9c-10.1 0-19.2-1.6-24.4-4.3-3-1.6-4.5-3.4-4.5-5.5v-8.3h3.1c0 0.8 1.1 1.8 2.8 2.8 4.7 2.4 13.5 4 23 4s18.3-1.5 23-4c1.8-0.9 2.8-2 2.8-2.8h3.1v8.3c0 2.1-1.5 4-4.5 5.5-5.2 2.6-14.3 4.3-24.4 4.3zm-25.8-13.4v3.6c0 0.8 1 1.8 2.8 2.8 4.7 2.4 13.5 4 23 4s18.3-1.5 23-4c1.8-0.9 2.8-1.9 2.8-2.8v-3.6c-0.4 0.3-0.9 0.5-1.4 0.8-5.2 2.7-14.3 4.3-24.4 4.3s-19.2-1.6-24.4-4.3c-0.5-0.3-1-0.6-1.4-0.8z"
}));

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "m299.9 238.5s-0.1 0 0 0c-0.3-0.1-0.6-0.1-1-0.2-2.4-0.5-3.6-0.9-3.6-1.2 0-0.2 0.2-0.4 0.6-0.5s1-0.2 1.7-0.2c1 0 1.7 0.1 2.1 0.3 0.5 0.2 0.7 0.5 0.7 0.8v0.1h4.9v-0.2c0-0.8-0.6-1.4-1.8-1.8-0.8-0.3-1.9-0.4-3.2-0.5v-1h-4.8v1c-1.3 0.1-2.4 0.2-3.3 0.5-1.3 0.4-2 0.9-2 1.6 0 0.5 0.4 0.9 1.2 1.3s2.6 0.9 5.6 1.5c0.2 0 0.4 0.1 0.6 0.1 1.9 0.4 2.8 0.7 2.8 1 0 0.2-0.2 0.4-0.7 0.5s-1.1 0.2-1.8 0.2c-1 0-1.7-0.1-2.1-0.3s-0.6-0.5-0.6-1v-0.1h-5v0.2s0 0.1 0 0.1c0 0.8 0.6 1.5 1.9 1.9 0.9 0.3 2 0.4 3.5 0.5v1h4.8v-1c1.4-0.1 2.5-0.2 3.4-0.5 1.4-0.4 2.1-0.9 2.1-1.6-0.2-0.8-2.1-1.7-6-2.5z",
  fill: "#fff"
});

var _ref51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "e",
  d: "m273.5 245.3c5.2 2.7 14.3 4.3 24.4 4.3s19.2-1.6 24.4-4.3c3.7-2 4.5-4.1 4.5-5.5v0 33.1c0 6.5-14.5 9.9-28.9 9.9s-28.9-3.4-28.9-9.9v-33.1c0 1.5 0.8 3.5 4.5 5.5z"
}));

var _ref52 = /*#__PURE__*/React.createElement("clipPath", {
  id: "d"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e"
}));

var _ref53 = /*#__PURE__*/React.createElement("polygon", {
  points: "332.9 286.9 301.2 287.7 301.2 235.4 332.9 234.6",
  clipPath: "url(#d)",
  enableBackground: "new",
  fill: "#F8CF44",
  opacity: 0.4
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "m258.9 248.5c-14.6 0-26.5 3.6-26.5 8v15.9c0 1.5 1.3 2.8 3.5 4 4.6 2.4 13.1 4 22.9 4s18.4-1.6 22.9-4c2.3-1.2 3.5-2.5 3.5-4v-15.9c0.2-4.4-11.7-8-26.3-8z",
  fill: "#FADD75"
});

var _ref55 = /*#__PURE__*/React.createElement("g", {
  fill: "#FCAB1E"
}, /*#__PURE__*/React.createElement("path", {
  d: "m258.9 266.1c-9.8 0-18.6-1.6-23.7-4.2-3.6-1.9-4.4-4-4.4-5.4 0-6.3 14.1-9.6 28-9.6s28 3.3 28 9.6c0 1.4-0.8 3.5-4.4 5.4-4.9 2.6-13.7 4.2-23.5 4.2zm0-16.1c-15.2 0-25 3.9-25 6.5 0 0.8 1 1.8 2.7 2.7 4.5 2.4 13.1 3.8 22.2 3.8 9.2 0 17.7-1.5 22.2-3.8 1.7-0.9 2.7-1.9 2.7-2.7 0.2-2.6-9.6-6.5-24.8-6.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m258.9 282.2c-9.8 0-18.6-1.6-23.7-4.2-2.9-1.5-4.4-3.3-4.4-5.4v-8h3c0 0.8 1 1.8 2.7 2.7 4.5 2.4 13.1 3.8 22.2 3.8 9.2 0 17.7-1.5 22.2-3.8 1.7-0.9 2.7-1.9 2.7-2.7h3v8c0 2-1.5 3.8-4.4 5.4-4.7 2.6-13.5 4.2-23.3 4.2zm-25-13v3.5c0 0.8 1 1.8 2.7 2.7 4.5 2.4 13.1 3.8 22.2 3.8 9.2 0 17.7-1.5 22.2-3.8 1.7-0.9 2.7-1.9 2.7-2.7v-3.5c-0.4 0.3-0.8 0.5-1.3 0.8-5 2.6-13.8 4.2-23.7 4.2-9.8 0-18.6-1.6-23.7-4.2-0.3-0.3-0.7-0.6-1.1-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m258.9 274.1c-9.8 0-18.6-1.6-23.7-4.2-2.9-1.5-4.4-3.3-4.4-5.4v-8h3c0 0.8 1 1.8 2.7 2.7 4.5 2.4 13.1 3.8 22.2 3.8 9.2 0 17.7-1.5 22.2-3.8 1.7-0.9 2.7-1.9 2.7-2.7h3v8c0 2-1.5 3.8-4.4 5.4-4.7 2.7-13.5 4.2-23.3 4.2zm-25-13v3.5c0 0.8 1 1.8 2.7 2.7 4.5 2.4 13.1 3.8 22.2 3.8 9.2 0 17.7-1.5 22.2-3.8 1.7-0.9 2.7-1.9 2.7-2.7v-3.5c-0.4 0.3-0.8 0.5-1.3 0.8-5 2.6-13.8 4.2-23.7 4.2-9.8 0-18.6-1.6-23.7-4.2-0.3-0.2-0.7-0.5-1.1-0.8z"
}));

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "m260.8 256c-0.3-0.1-0.6-0.1-0.9-0.2-2.3-0.5-3.5-0.9-3.5-1.2 0-0.2 0.2-0.3 0.6-0.5 0.4-0.1 0.9-0.2 1.6-0.2 0.9 0 1.6 0.1 2 0.3s0.6 0.4 0.6 0.8v0.1h4.8v-0.2c0-0.8-0.6-1.4-1.8-1.7-0.8-0.3-1.8-0.4-3.1-0.5v-1h-4.7v1c-1.3 0.1-2.3 0.2-3.2 0.5-1.3 0.3-1.9 0.9-1.9 1.5 0 0.5 0.4 0.9 1.1 1.3 0.8 0.4 2.6 0.8 5.4 1.4 0.1 0 0.3 0.1 0.6 0.1 1.8 0.4 2.7 0.7 2.7 1 0 0.2-0.2 0.4-0.7 0.5-0.4 0.1-1 0.2-1.8 0.2-1 0-1.7-0.1-2.1-0.3s-0.6-0.5-0.6-1v-0.1h-4.9v0.1 0.1c0 0.8 0.6 1.4 1.8 1.8 0.8 0.3 2 0.4 3.4 0.5v1h4.7v-1c1.3-0.1 2.4-0.2 3.3-0.5 1.3-0.4 2-0.9 2-1.5 0.3-0.7-1.6-1.5-5.4-2.3z",
  fill: "#fff"
});

var _ref57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "c",
  d: "m235.2 261.9c5 2.6 13.9 4.2 23.6 4.2 9.8 0 18.7-1.6 23.7-4.2 3.6-1.9 4.3-4 4.3-5.4v0 16c0 6.3-14.1 9.6-28 9.6s-28-3.3-28-9.6v-15.9c0.1 1.4 0.9 3.5 4.4 5.3z"
}));

var _ref58 = /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c"
}));

var _ref59 = /*#__PURE__*/React.createElement("polygon", {
  points: "292.8 286.1 262.1 286.9 262.1 252.4 292.8 251.6",
  clipPath: "url(#b)",
  enableBackground: "new",
  fill: "#F8CF44",
  opacity: 0.4
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "m28.7 199.2c15-0.2 27.2 3.4 27.3 8l0.9 82.4c0.1 4.6-12.1 8.4-27.1 8.6s-27.2-3.4-27.3-8l-0.9-82.4c-0.1-4.6 12.1-8.5 27.1-8.6z",
  fill: "#FADD75"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "m29.1 241.6c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.2 6.5 14.7 9.7 28.9 9.5zm25.5-13.6v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4s19.1-1.8 24.2-4.6c0.6-0.2 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "m29.2 249.9c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.4 14.6 9.7 28.9 9.5zm25.5-13.6v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.6-0.3 1-0.6 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "m29.1 233.4c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm25.4-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.6-0.3 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "m29.4 266.4c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.4 14.6 9.6 28.9 9.5zm25.5-13.7v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.6-0.2 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "m29.5 274.6c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.5 14.6 9.7 28.9 9.5zm25.5-13.6v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.3 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "m29.3 258.1c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.3 2.7 14.4 4.2 24.4 4.1zm25.5-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.6-0.2 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "m29.7 291.1c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.5 14.6 9.7 28.9 9.5zm25.5-13.6v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.3 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "m29.8 299.3c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.5 14.6 9.7 28.9 9.5zm25.5-13.6v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.2 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "m29.6 282.8c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.2 2.8 14.3 4.3 24.4 4.1zm25.5-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.2 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "m29 225.2c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm25.5-13.7v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.2 1-0.5 1.4-0.8z",
  fill: "#FCAB1E"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "m28.9 216.9c10.1-0.1 19.1-1.8 24.2-4.6 3.7-2 4.4-4.1 4.4-5.5-0.1-6.4-14.6-9.6-28.9-9.5-14.3 0.2-28.7 3.7-28.6 10.1 0 1.4 0.8 3.6 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm-0.2-16.5c15.7-0.2 25.7 3.7 25.7 6.4 0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7 0-2.7 9.9-6.8 25.6-7z",
  fill: "#FCAB1E"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "m30.7 206.5c-0.3-0.1-0.6-0.1-1-0.2-2.4-0.5-3.6-0.9-3.6-1.2 0-0.2 0.2-0.4 0.6-0.5s1-0.2 1.7-0.2c1 0 1.7 0.1 2.1 0.2 0.4 0.2 0.7 0.4 0.7 0.8v0.1l4.9-0.1v-0.2c0-0.8-0.6-1.4-1.8-1.8-0.8-0.3-1.9-0.4-3.2-0.5v-1l-4.8 0.1v1c-1.3 0.1-2.4 0.3-3.2 0.5-1.3 0.4-2 0.9-2 1.6 0 0.5 0.4 0.9 1.2 1.3s2.6 0.8 5.5 1.4c0.2 0 0.4 0.1 0.6 0.1 1.9 0.4 2.8 0.7 2.8 1 0 0.2-0.2 0.4-0.7 0.6-0.4 0.1-1.1 0.2-1.8 0.2-1 0-1.7-0.1-2.1-0.3s-0.6-0.5-0.6-1v-0.1l-5 0.1v0.2s0 0.1 0 0.1c0 0.8 0.6 1.5 1.9 1.8 0.9 0.3 2 0.4 3.5 0.5v1l4.8-0.1v-1c1.4-0.1 2.5-0.3 3.4-0.5 1.4-0.4 2-0.9 2-1.6s-2-1.5-5.9-2.3z",
  fill: "#fff"
});

var _ref73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "m91.3 288.2c-5.2-2.5-14.3-3.9-24.3-3.7-10.1 0.2-19.1 2-24.1 4.9-3.7 2-4.4 4.1-4.3 5.6v0l-0.2-8.2-0.2-8.2-0.2-8.2-0.2-8.2-0.2-8.2-0.2-8.2-0.2-8.2-0.2-8.2-0.2-8.2-0.2-8.2c-0.2-6.4 14.3-10.2 28.5-10.4 14.3-0.4 28.8 2.8 29 9.2l0.2 8.2 0.2 8.2 0.2 8.2 0.2 8.2 0.2 8.2 0.2 8.2 0.2 8.2 0.2 8.2 0.2 8.2 0.2 8.2c-0.4-1.7-1.2-3.7-4.8-5.6z"
}));

var _ref74 = /*#__PURE__*/React.createElement("clipPath", {
  id: "r"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
}));

var _ref75 = /*#__PURE__*/React.createElement("rect", {
  transform: "matrix(.9999 -.011024 .011024 .9999 -2.7622 .5419)",
  x: 32.7,
  y: 200.3,
  width: 30.2,
  height: 101.1,
  clipPath: "url(#r)",
  enableBackground: "new",
  fill: "#F8CF44",
  opacity: 0.4
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "m111.7 233.1c15-0.2 27.2 3.4 27.3 8l0.5 41.2c0 1.5-1.3 2.9-3.6 4.2-4.7 2.5-13.4 4.3-23.5 4.4s-18.9-1.5-23.6-3.9c-2.3-1.2-3.7-2.6-3.7-4.1l-0.5-41.2c-0.1-4.6 12.1-8.4 27.1-8.6z",
  fill: "#FADD75"
});

var _ref77 = /*#__PURE__*/React.createElement("g", {
  fill: "#FCAB1E"
}, /*#__PURE__*/React.createElement("path", {
  d: "m111.9 251.2c10.1-0.1 19.1-1.8 24.2-4.6 3.7-2 4.4-4.1 4.4-5.5-0.1-6.4-14.6-9.6-28.9-9.5-14.3 0.2-28.7 3.7-28.6 10.1 0 1.4 0.8 3.6 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm-0.2-16.5c15.7-0.2 25.7 3.7 25.7 6.4 0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7 0-2.8 10-6.9 25.6-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m112.2 275.9c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.4 14.6 9.6 28.9 9.5zm25.5-13.7v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4s19.1-1.8 24.2-4.6c0.5-0.2 1-0.5 1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m112.3 284.1c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.5 14.6 9.7 28.9 9.5zm25.5-13.6v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.3 0.9-0.5 1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m112.1 267.6c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm25.5-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.2 1-0.5 1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m112.4 292.4c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm25.4-13.7v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4s19.1-1.8 24.2-4.6c0.6-0.2 1-0.5 1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m112 259.4c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm25.5-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.3 1-0.6 1.4-0.8z"
}));

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "m113.8 240.7c-0.1 0-0.1 0 0 0-0.3-0.1-0.6-0.1-1-0.2-2.4-0.5-3.6-0.9-3.6-1.2 0-0.2 0.2-0.4 0.6-0.5s1-0.2 1.7-0.2c1 0 1.7 0.1 2.1 0.2 0.5 0.2 0.7 0.4 0.7 0.8v0.1l4.9-0.1v-0.2c0-0.8-0.6-1.4-1.8-1.8-0.8-0.3-1.9-0.4-3.2-0.5v-1l-4.8 0.1v1c-1.3 0.1-2.4 0.3-3.2 0.5-1.3 0.4-2 0.9-2 1.6 0 0.5 0.4 0.9 1.2 1.3s2.6 0.8 5.5 1.4c0.2 0 0.4 0.1 0.6 0.1 1.9 0.4 2.8 0.7 2.8 1 0 0.2-0.2 0.4-0.7 0.6-0.4 0.1-1.1 0.2-1.8 0.2-1 0-1.7-0.1-2.1-0.3s-0.6-0.5-0.6-1v-0.1l-5 0.1v0.2s0 0.1 0 0.1c0 0.8 0.6 1.5 1.9 1.8 0.8 0.3 2 0.4 3.5 0.5v1l4.8-0.1v-1c1.4-0.1 2.5-0.3 3.4-0.5 1.4-0.4 2-0.9 2-1.6-0.1-0.7-2-1.5-5.9-2.3z",
  fill: "#fff"
});

var _ref79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "q",
  d: "m136.1 246.6c-5.1 2.7-14.2 4.4-24.2 4.6-10.1 0.1-19.2-1.4-24.3-4-3.7-1.9-4.5-4-4.5-5.5v0l0.5 41.2c0.1 6.4 14.6 9.6 28.9 9.5 14.3-0.2 28.7-3.7 28.6-10.1l-0.5-41.2c-0.1 1.5-0.9 3.5-4.5 5.5z"
}));

var _ref80 = /*#__PURE__*/React.createElement("clipPath", {
  id: "p"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#q"
}));

var _ref81 = /*#__PURE__*/React.createElement("polygon", {
  points: "77.6 296.9 109.1 297.4 108.4 237.1 77 236.6",
  clipPath: "url(#p)",
  enableBackground: "new",
  fill: "#F8CF44",
  opacity: 0.4
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "m135.5 266.1c15-0.2 27.2 3.4 27.3 8l0.2 16.3c0 1.5-1.3 2.9-3.6 4.2-4.7 2.5-13.4 4.3-23.5 4.4s-18.9-1.5-23.6-3.9c-2.3-1.2-3.7-2.6-3.7-4.1l-0.2-16.3c-0.1-4.6 12.1-8.4 27.1-8.6z",
  fill: "#FADD75"
});

var _ref83 = /*#__PURE__*/React.createElement("g", {
  fill: "#FCAB1E"
}, /*#__PURE__*/React.createElement("path", {
  d: "m135.7 284.2c10.1-0.1 19.1-1.8 24.2-4.6 3.7-2 4.4-4.1 4.4-5.5-0.1-6.4-14.6-9.6-28.9-9.5-14.3 0.2-28.7 3.7-28.6 10.1 0 1.4 0.8 3.6 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm-0.2-16.5c15.7-0.2 25.7 3.7 25.7 6.4 0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7 0-2.8 10-6.8 25.6-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m135.9 300.7c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm25.5-13.7v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.5-0.2 1-0.5 1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m135.8 292.4c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm25.5-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4s19.1-1.8 24.2-4.6c0.5-0.3 1-0.5 1.4-0.8z"
}));

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "m137.6 273.8s-0.1 0 0 0c-0.3-0.1-0.6-0.1-1-0.2-2.4-0.5-3.6-0.9-3.6-1.2 0-0.2 0.2-0.4 0.6-0.5s1-0.2 1.7-0.2c1 0 1.7 0.1 2.1 0.2 0.5 0.2 0.7 0.4 0.7 0.8v0.1l4.9-0.1v-0.2c0-0.8-0.6-1.4-1.8-1.8-0.8-0.3-1.9-0.4-3.2-0.5v-1l-4.8 0.1v1c-1.3 0.1-2.4 0.3-3.2 0.5-1.3 0.4-2 0.9-2 1.6 0 0.5 0.4 0.9 1.2 1.3s2.6 0.8 5.5 1.4c0.2 0 0.4 0.1 0.6 0.1 1.9 0.4 2.8 0.7 2.8 1 0 0.2-0.2 0.4-0.7 0.6-0.4 0.1-1.1 0.2-1.8 0.2-1 0-1.7-0.1-2.1-0.3s-0.6-0.5-0.6-1v-0.1l-5 0.1v0.2s0 0.1 0 0.1c0 0.8 0.6 1.5 1.9 1.8 0.9 0.3 2 0.4 3.5 0.5v1l4.8-0.1v-1c1.4-0.1 2.5-0.3 3.4-0.5 1.4-0.4 2-0.9 2-1.6-0.1-0.8-2-1.6-5.9-2.3z",
  fill: "#fff"
});

var _ref85 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "o",
  d: "m159.9 279.6c-5.1 2.7-14.2 4.4-24.2 4.6-10.1 0.1-19.2-1.4-24.3-4-3.7-1.9-4.5-4-4.5-5.5v0l0.2 16.4c0.1 6.4 14.6 9.6 28.9 9.5 14.3-0.2 28.7-3.7 28.6-10.1l-0.2-16.3c-0.1 1.4-0.8 3.5-4.5 5.4z"
}));

var _ref86 = /*#__PURE__*/React.createElement("clipPath", {
  id: "n"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#o"
}));

var _ref87 = /*#__PURE__*/React.createElement("polygon", {
  points: "101.1 305.1 132.6 305.5 132.2 270.1 100.8 269.7",
  clipPath: "url(#n)",
  enableBackground: "new",
  fill: "#F8CF44",
  opacity: 0.4
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "m73.8 256.7c15-0.2 27.2 3.4 27.3 8l0.4 32.9c0 1.5-1.3 2.9-3.6 4.2-4.7 2.5-13.4 4.3-23.5 4.4s-18.9-1.5-23.6-3.9c-2.3-1.2-3.7-2.6-3.7-4.1l-0.4-32.9c-0.1-4.6 12-8.4 27.1-8.6z",
  fill: "#FADD75"
});

var _ref89 = /*#__PURE__*/React.createElement("g", {
  fill: "#FCAB1E"
}, /*#__PURE__*/React.createElement("path", {
  d: "m74 274.7c10.1-0.1 19.1-1.8 24.2-4.6 3.7-2 4.4-4.1 4.4-5.5-0.1-6.4-14.6-9.6-28.9-9.5-14.3 0.2-28.7 3.7-28.6 10.1 0 1.4 0.8 3.6 4.5 5.4 5.2 2.7 14.3 4.2 24.4 4.1zm-0.2-16.5c15.7-0.2 25.7 3.7 25.7 6.4 0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7 0-2.7 9.9-6.8 25.6-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m74.2 299.5c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.4 14.6 9.6 28.9 9.5zm25.5-13.7v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.6-0.2 1-0.5 1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m74.3 307.7c14.3-0.2 28.7-3.7 28.6-10.1l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0.1 6.5 14.6 9.7 28.9 9.5zm25.5-13.6v3.5c0 2.7-9.9 6.8-25.6 7s-25.7-3.7-25.7-6.4v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.6-0.3 1-0.5 1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m74.1 291.2c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.3 2.7 14.4 4.2 24.4 4.1zm25.5-13.6v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.6-0.3 1-0.5 1.4-0.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m74 283c10.1-0.1 19.1-1.8 24.2-4.6 2.9-1.6 4.4-3.5 4.4-5.5l-0.1-8.2h-3.1c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7h-3.1l0.1 8.2c0 2.1 1.5 3.9 4.5 5.4 5.3 2.7 14.4 4.2 24.4 4.1zm25.5-13.7v3.5c0 0.8-1 1.8-2.8 2.8-4.6 2.5-13.4 4.1-22.8 4.2s-18.2-1.3-22.9-3.7c-1.8-0.9-2.8-1.9-2.8-2.7v-3.5c0.4 0.3 0.9 0.5 1.4 0.8 5.2 2.6 14.3 4.1 24.3 4 10.1-0.1 19.1-1.8 24.2-4.6 0.6-0.2 1-0.5 1.4-0.8z"
}));

var _ref90 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "m",
  d: "m98.2 270.2c-5.1 2.7-14.2 4.4-24.2 4.6-10.1 0.1-19.2-1.4-24.3-4-3.7-1.9-4.5-4-4.5-5.5v0l0.4 33c0.1 6.4 14.6 9.6 28.9 9.5 14.3-0.2 28.7-3.7 28.6-10.1l-0.4-32.9c-0.1 1.3-0.9 3.4-4.5 5.4z"
}));

var _ref91 = /*#__PURE__*/React.createElement("clipPath", {
  id: "l"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#m"
}));

var _ref92 = /*#__PURE__*/React.createElement("polygon", {
  points: "39.6 312.2 71.1 312.7 70.5 260.7 39 260.2",
  clipPath: "url(#l)",
  enableBackground: "new",
  fill: "#F8CF44",
  opacity: 0.4
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "m49.6 242.8c0.1 13.3 11 23.9 24.3 23.8s23.9-11 23.8-24.3-11-23.9-24.3-23.8-24 11-23.8 24.3z",
  fill: "#FADD75"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "m73.9 268.1c14.1-0.2 25.5-11.8 25.3-25.9s-11.8-25.5-25.9-25.3-25.5 11.8-25.3 25.9 11.8 25.5 25.9 25.3zm-0.5-48c12.4-0.1 22.6 9.8 22.7 22.2s-9.8 22.6-22.2 22.7-22.6-9.8-22.7-22.2c-0.2-12.4 9.8-22.6 22.2-22.7z",
  fill: "#FCAB1E"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "m75.6 241s-0.1 0 0 0c-0.3-0.1-0.6-0.3-1-0.5-2.4-1.2-3.6-2.3-3.6-3.1 0-0.5 0.2-0.9 0.6-1.2s1-0.5 1.7-0.5c1 0 1.7 0.2 2.1 0.6 0.5 0.4 0.7 1.1 0.7 2.1v0.4l4.9-0.1v-0.4c0-2-0.6-3.6-1.9-4.6-0.8-0.7-1.9-1.1-3.2-1.3v-2.6l-4.8 0.1v2.6c-1.3 0.2-2.4 0.6-3.2 1.2-1.3 0.9-2 2.3-1.9 4 0 1.3 0.4 2.4 1.2 3.3s2.7 2.1 5.6 3.7l0.6 0.3c1.9 1 2.8 1.8 2.8 2.6 0 0.6-0.2 1.1-0.7 1.4-0.4 0.4-1.1 0.5-1.8 0.5-1 0-1.7-0.2-2.1-0.7s-0.6-1.3-0.6-2.6v-0.3l-5 0.1v0.4 0.4c0 2.2 0.7 3.7 1.9 4.7 0.9 0.7 2 1.1 3.5 1.3v2.6l4.8-0.1v-2.6c1.4-0.2 2.5-0.7 3.4-1.3 1.4-1 2-2.3 2-4.1-0.2-2.1-2.1-4.3-6-6.3z",
  fill: "#fff"
});

var _ref96 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "k",
  cx: 73.6,
  cy: 242.6,
  r: 25.6
}));

var _ref97 = /*#__PURE__*/React.createElement("clipPath", {
  id: "j"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#k"
}));

var _ref98 = /*#__PURE__*/React.createElement("polygon", {
  points: "50.2 277 80.8 269.2 65.7 215.9 35.1 223.7",
  clipPath: "url(#j)",
  enableBackground: "new",
  fill: "#F8CF44",
  opacity: 0.4
});

var SvgConsumo4 = function SvgConsumo4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 326.8 307.8",
    viewBox: "0 0 326.8 307.8",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConsumo4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/consumo4.34ba88a3.svg";
export { ForwardRef as ReactComponent };